module.exports = __webpack_public_path__ + "img/stock-order-draft.7a2c9332.svg";